import gql from 'graphql-tag';

export const updateChargeCode = gql(/* GraphQL */ `
  mutation UpdateChargeCode(
    $updateChargeCodeRequest: UpdateChargeCodeRequest!
  ) {
    updateChargeCode(updateChargeCodeRequest: $updateChargeCodeRequest) {
      chargeCode {
        id
        chargeCode
        glCode
        description
        groupId
        groupType
      }
    }
  }
`);
